/* Global Duniya — fun layer: Duniya buddy, WhatsApp button, hero mascot, festive toran, bottom-bar lift. */
(function () {
  if (window.__gdFun) return;
  window.__gdFun = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function store(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (e) {}
    return null;
  }

  function pick(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  /* Emoji burst used by the buddy and the hero mascot. */
  function burst(host, icons, count, spread) {
    if (reduce || !host) return;
    for (var i = 0; i < (count || 9); i++) {
      var s = document.createElement('i');
      s.textContent = icons[i % icons.length];
      var ang = ((-170 + Math.random() * 160) * Math.PI) / 180;
      var dist = (spread || 55) + Math.random() * (spread || 55);
      s.style.setProperty('--x', (Math.cos(ang) * dist).toFixed(0) + 'px');
      s.style.setProperty('--y', (Math.sin(ang) * dist).toFixed(0) + 'px');
      s.style.setProperty('--r', (Math.random() * 120 - 60).toFixed(0) + 'deg');
      s.style.animationDelay = i * 0.03 + 's';
      host.appendChild(s);
      setTimeout(
        (function (n) {
          return function () {
            n.remove();
          };
        })(s),
        1500
      );
    }
  }

  /* Tell the page when something was added to the cart (works with any theme form). */
  if (window.fetch && !window.__gdFetchWrapped) {
    window.__gdFetchWrapped = true;
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) {
          if (res && res.ok) {
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent('gd:cart-added'));
            }, 120);
          }
        }).catch(function () {});
      }
      return p;
    };
  }

  /* ---------- lift floating buttons above bottom bars (sticky add to cart, combo bar) ---------- */
  var floatEl = null;
  var liftRaf = 0;
  function measureLift() {
    liftRaf = 0;
    if (!floatEl) return;
    var lift = 0;
    var h = window.innerHeight;
    [6, 22, 40].forEach(function (dy) {
      var el = document.elementFromPoint(window.innerWidth / 2, h - dy);
      var guard = 0;
      while (el && el !== document.body && el !== document.documentElement && guard++ < 14) {
        if (floatEl.contains(el)) break;
        var pos = window.getComputedStyle(el).position;
        if (pos === 'fixed') {
          var r = el.getBoundingClientRect();
          if (r.bottom >= h - 30 && r.height < h * 0.4) lift = Math.max(lift, Math.round(h - r.top));
          break;
        }
        el = el.parentElement;
      }
    });
    floatEl.style.setProperty('--gd-lift', lift + 'px');
  }
  function queueLift() {
    if (!liftRaf) liftRaf = requestAnimationFrame(measureLift);
  }

  /* ---------- Duniya buddy ---------- */
  function initBuddy() {
    floatEl = document.querySelector('[data-gd-float]');
    var buddy = document.querySelector('[data-gd-buddy]');
    var jsonEl = document.querySelector('[data-gd-buddy-json]');
    if (!buddy || !jsonEl || buddy.dataset.ready) return;
    buddy.dataset.ready = '1';

    var data = {};
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {}
    var tips = data.tips || [];
    var bubble = buddy.querySelector('[data-gd-buddy-bubble]');
    var text = buddy.querySelector('[data-gd-buddy-text]');
    var cta = buddy.querySelector('[data-gd-buddy-cta]');
    var btn = buddy.querySelector('[data-gd-buddy-btn]');
    var fx = buddy.querySelector('[data-gd-buddy-fx]');
    var closeBtn = buddy.querySelector('[data-gd-buddy-close]');
    var hideTimer = 0;
    var peekTimer = 0;

    function play(cls) {
      if (reduce) return;
      buddy.classList.remove('is-wave', 'is-jump');
      void buddy.offsetWidth;
      buddy.classList.add(cls);
      setTimeout(function () {
        buddy.classList.remove(cls);
      }, 1800);
    }
    function peek(on) {
      buddy.classList.toggle('is-peek', on);
    }
    function schedulePeek(ms) {
      clearTimeout(peekTimer);
      peekTimer = setTimeout(function () {
        if (bubble.hidden) peek(true);
      }, ms || 8000);
    }
    function hide() {
      bubble.hidden = true;
      schedulePeek();
    }
    function say(msg, link, label, ms, external) {
      text.textContent = msg;
      if (link) {
        cta.href = link;
        cta.textContent = label || 'Open';
        cta.hidden = false;
        if (external) {
          cta.target = '_blank';
          cta.rel = 'noopener';
        } else {
          cta.removeAttribute('target');
        }
      } else {
        cta.hidden = true;
      }
      bubble.hidden = false;
      bubble.classList.remove('is-in');
      void bubble.offsetWidth;
      bubble.classList.add('is-in');
      peek(false);
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, ms || 7000);
    }
    function nextTip(ms) {
      if (!tips.length) return;
      var i = parseInt(store('gdBuddyTip') || '0', 10) || 0;
      var tip = tips[i % tips.length];
      store('gdBuddyTip', String(i + 1));
      say(tip.t, tip.u, tip.c, ms, tip.x);
    }

    btn.addEventListener('click', function () {
      play('is-wave');
      burst(fx, ['💖', '✨', '⭐'], 7, 40);
      nextTip(8000);
    });
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      store('gdBuddyQuiet', '1');
      clearTimeout(hideTimer);
      bubble.hidden = true;
      peek(true);
    });
    buddy.addEventListener('mouseenter', function () {
      clearTimeout(peekTimer);
    });
    buddy.addEventListener('mouseleave', function () {
      if (bubble.hidden) schedulePeek(5000);
    });

    document.addEventListener('gd:cart-added', function () {
      say(pick(data.added || ['Added to cart 🎉']), null, null, 4500);
      play('is-jump');
      burst(fx, ['🎉', '💖', '✨', '⭐', '🛍️'], 10, 50);
    });

    /* Appear after a short pause; greet automatically at most 3 times per visit. */
    setTimeout(function () {
      buddy.hidden = false;
      queueLift();
      var shown = parseInt(store('gdBuddyAuto') || '0', 10) || 0;
      if (store('gdBuddyQuiet') === '1' || shown >= 3) {
        schedulePeek(2500);
        return;
      }
      setTimeout(function () {
        store('gdBuddyAuto', String(shown + 1));
        play('is-wave');
        nextTip(7000);
      }, shown === 0 ? 900 : 5000);
    }, 1500);

    /* WhatsApp: show the "Chat with us" label once per visit. */
    var wa = document.querySelector('[data-gd-wa]');
    if (wa && !reduce && store('gdWaTease') !== '1' && window.matchMedia('(min-width: 750px)').matches) {
      setTimeout(function () {
        store('gdWaTease', '1');
        wa.classList.add('is-open');
        setTimeout(function () {
          wa.classList.remove('is-open');
        }, 3800);
      }, 2600);
    }

    window.addEventListener('scroll', queueLift, { passive: true });
    window.addEventListener('resize', queueLift);
    document.addEventListener('click', function () {
      setTimeout(queueLift, 450);
    });
    document.addEventListener('gd:cart-added', function () {
      setTimeout(queueLift, 600);
    });
    setTimeout(queueLift, 2500);
  }

  /* ---------- hero mascot ---------- */
  function initHeroMascot(scope) {
    var art = (scope || document).querySelector('[data-gd-hero] .gd-hero__art');
    var img = art && art.querySelector('.gd-hero__mascot');
    if (!img || art.dataset.gdFun) return;
    art.dataset.gdFun = '1';
    var festive = !!document.querySelector('[data-gd-float][data-festive]');

    var bubble = document.createElement('span');
    bubble.className = 'gd-hero__say';
    bubble.setAttribute('aria-hidden', 'true');
    bubble.textContent = festive ? 'Happy Diwali! 🪔' : 'Namaste! 🙏';
    art.appendChild(bubble);

    var canAnimate = !reduce && typeof img.animate === 'function';
    function wiggle() {
      if (!canAnimate || document.hidden) return;
      img.animate(
        [{ rotate: '0deg' }, { rotate: '-6deg' }, { rotate: '5deg' }, { rotate: '-3deg' }, { rotate: '0deg' }],
        { duration: 1000, easing: 'ease-in-out' }
      );
    }
    if (canAnimate) setInterval(wiggle, 7000);

    img.addEventListener('click', function (e) {
      if (canAnimate) {
        img.animate(
          [{ translate: '0 0' }, { translate: '0 -34px' }, { translate: '0 0' }, { translate: '0 -10px' }, { translate: '0 0' }],
          { duration: 900, easing: 'ease-out' }
        );
      }
      var rect = art.getBoundingClientRect();
      var host = document.createElement('span');
      host.className = 'gd-hero__fx';
      host.style.left = e.clientX - rect.left + 'px';
      host.style.top = e.clientY - rect.top + 'px';
      art.appendChild(host);
      burst(host, ['💖', '💗', '✨', '⭐', '🍼'], 10, 60);
      setTimeout(function () {
        host.remove();
      }, 1600);
    });
  }

  /* ---------- festive toran: hide after its date even if the page was cached ---------- */
  function checkToran() {
    document.querySelectorAll('[data-gd-until]').forEach(function (el) {
      var until = new Date(el.getAttribute('data-gd-until') + 'T23:59:59+05:30');
      if (!isNaN(until) && Date.now() > until.getTime()) el.remove();
    });
  }

  function start() {
    checkToran();
    initBuddy();
    initHeroMascot();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) {
    initHeroMascot(e.target);
  });
})();
